module.exports = __webpack_public_path__ + "static/media/liveDrawTop.22831945.png";